<template>
  <v-flex xs12 class="text-xs-center" v-if="$store.state.tips.loadingTips">
    <v-progress-circular indeterminate :color="$store.state.global.pages[$route.name].color"></v-progress-circular>
  </v-flex>
  <transition name="fadeToggle" mode="out-in" v-else>
    <v-flex xs12 v-if="listView">
      <v-card hover>
        <v-data-table
          :items="filteredTips"
          :headers="headers"
          :rows-per-page-items="itemsPerPageOptions"
        >
          <template slot="items" slot-scope="props">
            <table-row :headers="headers" :row="props.item" parent="Tip" :key="props.item.id"></table-row>
          </template>
        </v-data-table>
      </v-card>
    </v-flex>

    <transition-group name="data-list" tag="layout-no-padding" v-else>
      <v-flex xs12 sm6 md4 xl3 v-for="(tip,i) in filteredTips" :key="tip.id" class="data-list-item">
        <tip-card :tip="tip" :index="i"></tip-card>
      </v-flex>
    </transition-group>
  </transition>
</template>

<script>
import Store from '@/store/computed/storeHelpers'
import TipService from '@/services/requests/tipService'
import TipCard from '@/components/tips/tipCard'
import TableRow from '@/components/ui/masterFileTableRow'
import FilterByProps from '@/services/mixins/filterByProps'
export default {
  mixins: [FilterByProps],
  data() {
    return {
      headers: [
        {
          text: 'Name',
          align: 'left',
          value: 'name'
        },
        {
          text: 'Tip Number',
          align: 'left',
          value: 'number'
        },
        {
          text: 'Email',
          align: 'left',
          value: 'contactEmail'
        },
        {
          text: 'Details',
          align: 'right',
          value: 'details'
        },
        {
          text: 'Actions',
          align: 'center',
          sortable: false
        }
      ],
      filters: ['name', 'number']
    }
  },
  computed: {
    sortBy: Store.getSet({ store: 'tips', prop: 'sortBy' }),
    filterBy: Store.getSet({ store: 'tips', prop: 'filterBy' }),
    tips: Store.getSet({ store: 'tips', prop: 'tips' }),
    listView: Store.getSet({ store: 'tips', prop: 'listView' }),
    selectedRecordType: Store.getSet({
      store: 'tips',
      prop: 'selectedRecordType'
    }),
    sortedTips() {
      if (this.sortBy) {
        var path = this.sortBy
        return this.tips.sort((a, b) => {
          //if(a[property] < b[property])
          if (this.getObjectPath(path, a) < this.getObjectPath(path, b)) {
            if (path == 'updatedAt') {
              return 1
            }
            return -1
          } else {
            if (path == 'updatedAt') {
              return -1
            }
            return 1
          }
        })
      } else {
        return this.tips
      }
    },
    filteredTips() {
      // return this.filterListByMultipleProps(this.sortedTips, this.filters)

      return this.sortedTips.filter(tip => {
        const nameMatch =
          tip.name.toLowerCase().indexOf(this.filterBy.toLowerCase()) > -1
        const numberMatch = tip.number
          ? tip.number.toLowerCase().indexOf(this.filterBy.toLowerCase()) > -1
          : null
        if (this.selectedRecordType === 'Request')
          return (nameMatch || numberMatch) && tip.request
        else return (nameMatch || numberMatch) && !tip.request
      })
    }
  },
  components: {
    TipCard,
    TableRow
  }
}
</script>

<style scoped>
</style>
